import { EventEmitter, Injectable, Output } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { Filter } from '../../constants/Filters';
import { RolType } from '../../models/types/rol.types';
import { UserLogged } from '../../models/user.logged.model';
import { MessagingService } from '../firebase/messaging.service';
import { SupportService } from '../support/support.service';
import { UserService } from './user.service';

export const TOKEN_NAME = 'token';
export const TOKEN_USER = '_u';
export const TOKEN_URL = 'url';
@Injectable()
export class AuthService {

  @Output() readonly resfreshNewUser: EventEmitter<any> = new EventEmitter();
  role = new RolType();

  constructor(
    private userService: UserService,
    private readonly messagingService: MessagingService,
    private readonly supportService: SupportService
  ) {

  }

  getToken(): string {
    //return localStorage.getItem(TOKEN_NAME);
    return this.getCookie(TOKEN_NAME);
  }

  setToken(token: string): void {
    //localStorage.setItem(TOKEN_NAME, token);
    this.setCookie(TOKEN_NAME,token)
  }

  getUser(): UserLogged {
    //return JSON.parse(localStorage.getItem(TOKEN_USER));
    return JSON.parse(this.getCookie(TOKEN_USER));
  }

  setUser(user: UserLogged): void {
    //localStorage.setItem(TOKEN_USER, JSON.stringify(user));
    this.setCookie(TOKEN_USER, JSON.stringify(user));
  }

  getUserRol(): string {
    const helper = new JwtHelperService();

    const decoded = helper.decodeToken(this.getCookie(TOKEN_NAME));
    if (!decoded) {
      return null;
    }
    return decoded && decoded.role ? decoded.role : null;
  }

  canShowElement(...rolesPermitted: string[]): boolean {
    return rolesPermitted.includes(this.getUserRol());
  }

  getUrl(): string {
    return localStorage.getItem(TOKEN_URL);
  }

  setUrl(url: string): void {
    localStorage.setItem(TOKEN_URL, url);
  }

  isTestAB(): boolean {
    const company = JSON.parse(this.getCookie(TOKEN_USER)).company.companyConfiguration;
    return company ? company.testAb : false;
  }

  isLeadinLiveActived(): boolean {
    const company = JSON.parse(this.getCookie(TOKEN_USER)).company.companyConfiguration;
    return company ? company.leadinLive : false;
  }

  getTokenExpirationDate(token: string): Date {
    const helper = new JwtHelperService();

    const decoded = helper.decodeToken(token);

    if (decoded.exp === undefined) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);

    return date;
  }

  refreshToken(email: string): Observable<any> {
    return this.userService.refreshJWTToken$(email).pipe(
      tap((result) => {
        this.setToken(result.data.refreshToken.accessToken);
      }),
    );
  }

  isTokenExpired(token?: string): boolean {
    // TODO: implement
    let tokenTemp: string;

    if (!token) {
      tokenTemp = this.getToken();
    }
    if (!tokenTemp) {
      return true;
    }

    return false;

    // const date = this.getTokenExpirationDate(token);
    // if (date === undefined) {
    //   return false;
    // }
    // return !(date.valueOf() > new Date().valueOf());
  }

  logout(): void {
    const token = this.getCookie(TOKEN_NAME);
    if (!token) {
      return;
    }

    //this.supportService.unload();
    this.messagingService.deleteToken();

    this.deleteCookie(TOKEN_NAME);
    this.deleteCookie(TOKEN_USER);
    localStorage.removeItem(Filter.DASHBOARD);
    localStorage.removeItem(Filter.NEW_DASHBOARD);
    localStorage.removeItem(Filter.SALES);
    localStorage.removeItem(Filter.MARKETING);
    localStorage.removeItem(Filter.LEADS);
    if (window.caches) {
      window.caches.keys().then(
        keys => keys.map(
          key => {
            if (key.indexOf('api-performance') !== -1) {
              window.caches.open(key).then(
                cache => cache.keys().then(
                  keys2 => keys2.map(cacheitem => cache.delete(cacheitem))
                )
              );
            }
          })
      );
    }

  }

  refreshViewWithNewUser(getMenu?: boolean): void {
    this.resfreshNewUser.emit(getMenu);
  }

  hasDropdownRulesTheUserRole() {
    const user = this.getUser();
    return this.canShowElement(this.role.ROLE_USER) && this.existsConfigurationWithDropdownRules(user);
  }

  private existsConfigurationWithDropdownRules(user: UserLogged) {
    return user.company && user.company.companyConfiguration && user.company.companyConfiguration.dropdownWithRules;
  }


  private setCookie(cname, cvalue) {
    const d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/; Domain=." + this.getCookieDomain();
  }

  private getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  private deleteCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain=.' + this.getCookieDomain();
  }

  private getCookieDomain() {
    return window.location.hostname.split('.').slice(-2).join('.');
  }  
}
